module.exports = __webpack_public_path__ + "img/wiva-wila-diagram.04385cf5.png";